import * as React from 'react';

const NoConversations: React.FC<React.SVGProps<SVGSVGElement>> = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='160'
		height='160'
		viewBox='0 0 160 160'
		fill='none'>
		<path
			d='M123 96C123 110.912 110.912 123 96 123C81.0883 123 69 110.912 69 96C69 81.0883 81.0883 69 96 69C110.912 69 123 81.0883 123 96Z'
			fill='black'
		/>
		<foreignObject x='5' y='5' width='149' height='149'>
			<div
				style={{
					backdropFilter: 'blur(15px)',
					clipPath: 'url(#bgblur_no_conversations_clip)',
					height: '100%',
					width: '100%',
				}}
			/>
		</foreignObject>
		{/* Chat bubble shape */}
		<path
			data-figma-bg-blur-radius='30'
			d='M35 52C35 44.268 41.268 38 49 38H111C118.732 38 125 44.268 125 52V92C125 99.732 118.732 106 111 106H72L52 122V106H49C41.268 106 35 99.732 35 92V52Z'
			fill='#D3D3D3'
			fillOpacity={0.3}
		/>
		{/* Tail shadow */}
		<path d='M72 106L52 122V106H72Z' fill='#D9D9D9' fillOpacity={0.2} />
		{/* Three dots (ellipsis) */}
		<circle cx='64' cy='72' r='5' fill='white' />
		<circle cx='80' cy='72' r='5' fill='white' />
		<circle cx='96' cy='72' r='5' fill='white' />
		<defs>
			<clipPath id='bgblur_no_conversations_clip' transform='translate(-5 -5)'>
				<path d='M35 52C35 44.268 41.268 38 49 38H111C118.732 38 125 44.268 125 52V92C125 99.732 118.732 106 111 106H72L52 122V106H49C41.268 106 35 99.732 35 92V52Z' />
			</clipPath>
		</defs>
	</svg>
);

export default NoConversations;
